throw new Error('cannot use node modules in the browser')